import React, { useState } from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import ColorPalette from '../../colorpalette/ColorPalette';
import TutorialDialog from './TutorialDialog';

/**
 * Atalho "Como usar esta tela": abre as lições recebidas em modal.
 * Não renderiza nada quando não há lição.
 * @param {Array} lessons
 * @param {String} label - texto do botão
 * @param {Boolean} compact - só o ícone (com tooltip)
 */
const TutorialHelpButton = ({ lessons, label = 'Como usar esta tela', compact }) => {
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');

  if (!lessons || lessons.length === 0) return null;

  const iconOnly = compact ?? isMobile;

  return (
    <>
      {iconOnly ? (
        <Tooltip title={label} arrow>
          <IconButton
            size="small"
            onClick={() => setOpen(true)}
            aria-label={label}
            sx={{ color: ColorPalette.blueMain, '&:hover': { backgroundColor: 'var(--color-blue-light4)' } }}
          >
            <PlayCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          size="small"
          onClick={() => setOpen(true)}
          startIcon={<PlayCircleOutlineIcon />}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '999px',
            px: 1.75,
            whiteSpace: 'nowrap',
            color: ColorPalette.blueMain,
            backgroundColor: ColorPalette.blueAlpha,
            '&:hover': { backgroundColor: 'var(--color-blue-light4)' }
          }}
        >
          {label}
        </Button>
      )}
      <TutorialDialog open={open} onClose={() => setOpen(false)} lessons={lessons} />
    </>
  );
};

export default TutorialHelpButton;
